// Presentation helpers for the alert nouns (docs/09 §7: alert rules, alert
// channels, alert events). Moved verbatim from the pre-sweep Alerts.tsx in
// the UI Layering Sweep Phase 2 restructure — semantics unchanged.

import type { components } from "../../api/schema";

type AlertChannel = components["schemas"]["AlertChannelResponse"];
type AlertRule = components["schemas"]["AlertRuleResponse"];
type AlertEvent = components["schemas"]["AlertEventResponse"];

export function configSummary(channel: AlertChannel): string {
  if (channel.channel_type === "slack") {
    const config = channel.config;
    return config && "channel_name" in config
      ? `Slack #${config.channel_name}`
      : "Slack";
  }
  if (channel.channel_type === "email") {
    const config = channel.config;
    if (config != null && "to_addresses" in config) {
      return config.to_addresses.join(", ");
    }
    return "Email";
  }
  if (channel.channel_type === "pagerduty") {
    return "PagerDuty Events API v2";
  }
  if (channel.channel_type === "incident_io") {
    return "incident.io Alerts API";
  }
  return "Generic webhook";
}

export function ruleSummary(rule: AlertRule): string {
  const trigger = rule.trigger;
  if (trigger.kind === "event") {
    return trigger.target === "scheduled_run_failed"
      ? "Scheduled run failed"
      : "Batch completed";
  }
  return `${trigger.metric}.${trigger.measure} ${trigger.comparator} ${String(trigger.threshold)}`;
}

export function deliverySummary(event: AlertEvent): string {
  const deliveries = event.deliveries ?? [];
  if (deliveries.length === 0) {
    return "pending";
  }
  return deliveries
    .map((delivery) => `${delivery.status}:${String(delivery.attempts)}`)
    .join(", ");
}
